import Search from '@mui/icons-material/Search';
import { useContext } from 'react';

import { TemplatePlaceholder } from '@/types';
import TemplateCapableFetchAutocomplete, {
  TemplateCapableFetchAutocompleteChangeReason,
} from '@/components/TemplateCapableFetchAutocomplete';
import { SearchTemplatePageContext } from '@/context/SearchTemplateContext';
import { EventTypeRecord, getEventTypes } from '@/apis/eventTypes';
import { useAuth0 } from '@auth0/auth0-react';
import { labelSorting } from '@/util/labelSorting';

type EventTypeProps = {
  onChange: (
    newValue: EventTypeRecord[] | TemplatePlaceholder,
    reason: TemplateCapableFetchAutocompleteChangeReason
  ) => void;
  value: EventTypeRecord[] | TemplatePlaceholder;
  isAdvancedSearch?: boolean;
  error?: boolean;
};

const EventTypes = ({
  value = [] as EventTypeRecord[],
  onChange = () => {},
  isAdvancedSearch,
  error = false,
}: EventTypeProps) => {
  const { getAccessTokenSilently } = useAuth0();
  const inSearchTemplate = useContext(SearchTemplatePageContext);
  let allLists: EventTypeRecord[];
  const lookup = async (lookupValue: string) => {
    const token = await getAccessTokenSilently();
    if (!allLists) {
      const all = await getEventTypes(token);
      // eslint-disable-next-line react-hooks/immutability -- cache event types for this lookup instance
      allLists = all;
    }
    const lists = allLists
      .filter((x) => x.label.toLowerCase().includes(lookupValue.toLowerCase()))
      .sort(labelSorting);

    return lists;
  };

  return (
    <TemplateCapableFetchAutocomplete
      sx={isAdvancedSearch ? { width: '45ch' } : {}}
      // eslint-disable-next-line react-hooks/immutability -- lookup caches event types on this instance
      lookup={lookup}
      minLength={3}
      label="Event type(s) (optional)"
      value={value}
      onChange={onChange}
      data-testid="getfiltereventtypes"
      loadingText="Looking for event types..."
      noOptionsText="No event types found"
      popupIcon={<Search />}
      disableIconFlip
      isOnTemplatePage={inSearchTemplate}
      templateBuilderDisplayName="Event attendance filter: Event type"
      error={error}
    />
  );
};

export default EventTypes;
